import { CheckIcon, XIcon } from "@heroicons/react/outline";

export interface Plan {
  name: string;
  price: number;
  description: string;
  popular: boolean;
}

export type PlanFeatures = Record<string, string | JSX.Element | undefined>;

export const PLANS: Plan[] = [
  {
    name: "Free",
    price: 0,
    description: "For hackers",
    popular: false,
  },
  {
    name: "Pro",
    price: 49,
    description: "For small teams",
    popular: false,
  },
  {
    name: "Team",
    price: 500,
    description: "For growing teams",
    popular: true,
  },
  {
    name: "Enterprise",
    price: 0,
    description: "For large organizations",
    popular: false,
  },
];

export const PLAN_FEATURES: Record<string, PlanFeatures> = {
  free: {
    Prompts: "10",
    Requests: "2.5k/month",
    "Workflow Node Executions": "750/month",
    "Eval Cell Executions": "250/month",
    "Playground Runs": "10/day",
    Users: "5",
    Datasets: "10MB per dataset",
    Workspaces: "1",
    "Public Deployments": "1",
    "Private Deployments": "-",
    Webhooks: <XIcon className="h-4 w-4 text-red-500" />,
    RBAC: <XIcon className="h-4 w-4 text-red-500" />,
    "Overage Rate": "-",
  },
  pro: {
    Prompts: "Unlimited",
    Requests: "2.5k+/month",
    "Workflow Node Executions": "750+/month",
    "Eval Cell Executions": "250+/month",
    "Playground Runs": "Unlimited",
    Users: "5",
    Datasets: "150MB per dataset",
    Workspaces: "Unlimited",
    "Public Deployments": "Unlimited",
    "Private Deployments": "3",
    Webhooks: <XIcon className="h-4 w-4 text-red-500" />,
    RBAC: <XIcon className="h-4 w-4 text-red-500" />,
    "Overage Rate": "$0.003/txn",
  },
  team: {
    Prompts: "Unlimited",
    Requests: "100k+/month",
    "Workflow Node Executions": "10k+/month",
    "Eval Cell Executions": "7.5k+/month",
    "Playground Runs": "Unlimited",
    Users: "25",
    Datasets: "1GB per dataset",
    Workspaces: "Unlimited",
    "Public Deployments": "Unlimited",
    "Private Deployments": "Unlimited",
    Webhooks: <CheckIcon className="h-4 w-4 text-green-500" />,
    RBAC: <XIcon className="h-4 w-4 text-red-500" />,
    "Overage Rate": "$0.002/txn",
  },
  enterprise: {
    Prompts: "Unlimited",
    Requests: "Custom",
    "Workflow Node Executions": "Custom",
    "Eval Cell Executions": "Custom",
    "Playground Runs": "Custom",
    Users: "Unlimited",
    Datasets: "Custom",
    Workspaces: "Unlimited",
    "Public Deployments": "Custom",
    "Private Deployments": "Custom",
    Webhooks: <CheckIcon className="h-4 w-4 text-green-500" />,
    RBAC: <CheckIcon className="h-4 w-4 text-green-500" />,
    "Overage Rate": "Custom",
  },
};

export const getPlanFeatures = (planName: string): PlanFeatures =>
  PLAN_FEATURES[planName.toLowerCase()] || {};
